import { mapEnumToOptions } from '@abp/ng.core';

export enum IncidentStatus {
  Registered = 0,
  BeingResolved = 1,
  Resolved = 2,
}

export const incidentStatusOptions = mapEnumToOptions(IncidentStatus);
